@import '../../../globals/main.scss';

$animationDuration: 20s;

pn-media-block {
  .media-block {
    .media-block__block-container {
      display: grid;
      overflow: hidden;
    }
    .media-block__media-container,
    .media-block__content-container,
    .media-block__overlay-filter {
      grid-area: 1 / 1;
      width: 100%;
      position: relative;
    }

    .media-block__media-container {
      height: 100vh;
      overflow: hidden;
      position: relative;

      img,
      video {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        object-fit: cover;
        pointer-events: none;
        max-width: 100%;
        max-height: none;
        height: 100%;
        width: 100%;
        pointer-events: none;
      }

      pn-play-on-scroll {
        width: 100%;
        height: 100%;
      }

      .scroll-wrapper {
        width: 100%;
        height: 100%;
      }

      [slot='scroll-affected'] {
        width: 100%;
        height: 100%;
        display: flex;
      }

      .scroll-wrapper,
      .scroll-affected {
        width: 100%;
        height: 100%;
        display: flex;
      }
      video {
        width: 100%;
        height: 100%;
      }
    }

    .media-block__overlay-filter {
      z-index: 2;
    }

    .media-block__content-container {
      z-index: 3;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: opacity 1s;
      flex-direction: column;
      margin: 0 auto;
      padding: 3.4rem 0;

      @include inner-container;

      @media screen and (min-width: $min-width-lg) {
        padding: 6.4rem 0;
      }

      @media screen and (min-width: $min-width-xl) {
        padding: 7.2rem 0;
      }

      @media screen and (min-width: $min-width-xxl) {
        padding: 8rem 0;
      }

      .media-block__block-heading {
        max-width: 100rem;
        text-wrap: balance;
        color: white;
        font-size: 3.2rem;
        text-align: center;
        font-weight: 700;
        line-height: 1.1;
        margin-bottom: 3rem;

        @media screen and (min-width: $min-width-sm) {
          font-size: 4rem;
        }

        @media screen and (min-width: $min-width-md) {
          font-size: 4.8rem;
        }

        @media screen and (min-width: $min-width-lg) {
          font-size: 5.6rem;
        }

        @media screen and (min-width: $min-width-xl) {
          font-size: 8rem;
        }

        @media screen and (min-width: $min-width-xxl) {
          font-size: 8.8rem;
        }
      }

      .media-block__preamble {
        max-width: 80rem;
        max-width: 80ch;
        text-wrap: balance;
        display: flex;
        color: white;
        font-size: 1.8rem;
        text-align: center;
        font-weight: 300;

        @media screen and (min-width: $min-width-sm) {
          font-size: 2rem;
        }

        @media screen and (min-width: $min-width-xl) {
          font-size: 2.4rem;
        }

        @media screen and (min-width: $min-width-xxl) {
          font-weight: 500;
        }
      }

      .media-block__cta-link {
        margin-top: 3rem;
      }
    }
  }

  .media-block--height-100svh {
    min-height: 100vh;

    @supports (height: 100svh) {
      height: 100svh;
    }

    .media-block__block-container {
      height: 100vh;

      @supports (max-height: 100svh) {
        max-height: 100svh;
      }

      .media-block__media-container,
      .media-block__content-container,
      .media-block__overlay-filter {
        height: 100vh;

        @supports (max-height: 100svh) {
          max-height: 100svh;
        }
      }

      .media-block__media-container picture {
        height: 100vh;

        @supports (max-height: 100svh) {
          max-height: 100svh;
        }
      }
    }
  }

  .media-block--height-65svh {
    min-height: 65svh;
    overflow: auto;

    .media-block__block-container {
      height: 65vh;

      @supports (max-height: 100svh) {
        max-height: 65svh;
      }

      .media-block__media-container,
      .media-block__content-container,
      .media-block__overlay-filter {
        height: 65vh;

        @supports (max-height: 100svh) {
          max-height: 65svh;
        }
      }
    }

    .media-block__media-container picture {
      max-height: none !important;
      height: auto !important;
    }
  }

  .media-block--height-dynamic {
    height: auto;
    overflow: auto;

    .media-block__block-container {
      height: auto;
      max-height: none;

      .media-block__media-container,
      .media-block__content-container,
      .media-block__overlay-filter {
        height: auto;
        max-height: none;
      }
    }
  }

  .media-block--with-overlay {
    .media-block__block-container .media-block__overlay-filter {
      z-index: 2;
      background: radial-gradient(circle, rgba(13, 35, 75, 0.68) 7%, rgba(13, 35, 75, 0) 80%);
    }
  }

  .media-block--fixed-background {
    .media-block__block-container {
      .media-block__media-container,
      .media-block__overlay-filter {
        position: relative;
        overflow: hidden;
        top: 0;
        width: 100%;
        display: flex !important;
        clip-path: inset(0);
      }

      .media-block__media-container {
        picture {
          position: absolute;
          top: 0;
          width: 100%;
          display: flex !important;
          height: 100%;

          img {
            position: fixed;
            width: 100%;
            height: 100%;
            object-fit: cover;
            z-index: 1;
          }
        }
      }
    }
  }

  .media-block--video {
    .media-block__content-container {
      max-width: 80%;
    }
  }

  .media-block--animate-overlay-background {
    .media-block__overlay-filter {
      background-size: 200% 200% !important;
      animation: overlayBackgroundAnimation $animationDuration ease infinite;
    }
  }

  @keyframes overlayBackgroundAnimation {
    0% {
      background-position: 100% 100%;
    }
    50% {
      background-position: 50% 60%;
    }
    100% {
      background-position: 100% 100%;
    }
  }

  .media-block--margin-bottom {
    margin-bottom: 3.2rem;

    @media screen and (min-width:$min-width-md) {
      margin-bottom: 4rem;
    }

    @media screen and (min-width:$min-width-lg) {
      margin-bottom: 5.6rem;
    }

    @media screen and (min-width:$min-width-xl) {
      margin-bottom: 7.2rem;
    }
  }
}
